<template>
    <div class="inc_right">
        <div class="inctitall">
            <!--上架日期-->
            <div class="inc_date" v-if="onlineDate || onlinePlace ">
                <span>{{onlineDate}}</span>
                |
                <span>{{onlinePlace }}</span>
            </div>
            <!--標題-->
            <div class="inc_mtitle">
                {{title}}
            </div>
            <!--標籤-->
            <div class="inc_tag" v-if="useTag">
                <!-- TODO 動態抓取需顯示固定標籤-->
                <div class="hmdtag tag_org">
                    Event
                </div>
                <div class="hmdtag tag_pink">
                    announcement
                </div>
            </div>
        </div>
        <div class="intaxwall" v-html="content">
        </div>
        <Upload v-if="fileData && fileData.length > 0" :file-data="fileData" :className="className">
        </Upload>
    </div>
</template>
<script>
import Upload from '../Tool/Upload.vue';

export default {
    components:{
        Upload
    },
    data(){
        return{
            //上架時間
            onlineDate:"",
            //上架位置
            onlinePlace:"",
            //文章標題
            title:"",
            //文章內容
            content:"",
            //是否使用標籤
            useTag:true,
        };
    },
    props:["sideright" , "className"],
    mounted(){
        //初始化
        this.init();
    },
    watch:{
        "sideright"(){
            this.init()
        }
    },
    methods:{
        init(){
            //2025-11-14 讀取FAQ下拉功能
            const script = document.createElement("script");
            script.setAttribute('nonce', 'SHhzTzNmaWIxZjZJWmVsRg==');
            script.src = "/js/faq.js";
            document.body.appendChild(script);

            this.onlineDate = this.sideright.onlineDate;
            this.onlinePlace = this.sideright.onlinePlace;
            this.title = this.sideright.title;
            this.content = this.sideright.content;
            this.useTag = this.sideright.useTag;
            this.fileData=  this.sideright.filedata;
        }
    }

}
</script>